import React from "react";
import { Table, Label, Icon, Popup } from "semantic-ui-react";
import BotonAnimado from "../../../shared/botones/BotonAnimado";
import BotonBorrar from "../../../shared/botones/BotonBorrar";
import moment from "moment";

class Fila extends React.Component {
  click = () => this.props.handleClick(this.props.idInscripcion);

  handleConfirm = () =>
    this.props.handleConfirm({
      idInscripcion: this.props.idInscripcion,
      formaDePago: this.props.formaDePago
    });

  handleMatinal = () => this.props.handleMatinal(this.props.idInscripcion);

  handleVespertina = () =>
    this.props.handleVespertina(this.props.idInscripcion);

  handleMyV = () => this.props.handleMyV(this.props.idInscripcion);
  calcularEdad = () => moment().diff(moment(this.props.nacimiento), "years");

  render(props) {
    const {
      nombre,
      apellido1,
      telefonos,
      notas,
      servicios,
      matinal,
      vespertina,
      idInscripcion,
      formaDePago,
      adjuntos
    } = this.props;

    return (
      <React.Fragment>
        <Table.Row>
          <Table.Cell
            content={nombre}
            onClick={this.click}
            className="aristas-pointer"
          />
          <Table.Cell
            content={apellido1}
            onClick={this.click}
            className="aristas-pointer"
          />
          <Table.Cell
            content={this.calcularEdad()}
            onClick={this.click}
            textAlign="center"
            className="aristas-pointer"
          />
          <Table.Cell
            content={telefonos}
            onClick={this.click}
            className="aristas-pointer"
          />
          <Table.Cell
            content={servicios}
            onClick={this.click}
            className="aristas-pointer"
            textAlign="center"
          />
          <Table.Cell
            textAlign="center"
            onClick={this.click}
            className="aristas-pointer"
          >
            <Label
              size="small"
              content={formaDePago.toUpperCase()}
              color={
                formaDePago === "efectivo"
                  ? "green"
                  : formaDePago === "transferencia"
                    ? "blue"
                    : formaDePago === "desconocida"
                      ? "red"
                      : "grey"
              }
            />
          </Table.Cell>
          <Table.Cell
            textAlign="center"
            onClick={this.click}
            className="aristas-pointer"
          >
            <Popup
              content={adjuntos ? "Tiene ficheros adjuntos" : "No hay ficheros"}
              trigger={
                <Icon
                  name={adjuntos ? "file outline" : "ellipsis horizontal"}
                />
              }
            />
          </Table.Cell>
          <Table.Cell singleLine>
            <BotonAnimado
              basic
              circular
              icon="check"
              onClick={this.handleConfirm}
              textAlign="center"
              size="mini"
              popup="Confirmar Presinsripcion"
            />
            <BotonAnimado
              basic={!matinal}
              circular
              buttonText="M"
              onClick={this.handleMatinal}
              color={matinal ? "green" : "grey"}
              textAlign="center"
              size="mini"
              popup="Opción Matinal"
            />
            <BotonAnimado
              basic={!vespertina}
              circular
              buttonText="V"
              onClick={this.handleVespertina}
              color={vespertina ? "green" : "grey"}
              textAlign="center"
              size="mini"
              popup="Opción Vespertina"
            />
            <BotonBorrar
              data={{ idInscripcion }}
              handleClick={this.props.handleBorrarLinea}
              headerText={`Borrar de la lista`}
              content={`¿Desea eliminar a ${nombre} ${apellido1} de la lista?`}
              floated={null}
              size="mini"
            />
          </Table.Cell>
        </Table.Row>
        <Table.Row warning>
          <Table.Cell content={idInscripcion} />
          <Table.Cell content={notas} colSpan={7} />
        </Table.Row>
      </React.Fragment>
    );
  }
}

export default Fila;



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/listaPreinscripciones/tabla/Fila.jsx